module.exports = __webpack_public_path__ + "img/9_natalie_n.b60b8149.png";